import { IUser } from '@app/models/user.interface';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserActions from '../actions/user.actions';

export const userFeatureKey = 'user';

export interface State {
  users: IUser[],
  me: IUser,
  currentPage: number,
  total: number,
  sortType: string
  direction: string,
  pageSize: number,
}

export const initialState: State = {
  users: [],
  me: null,
  total: 0,
  currentPage: 0,
  sortType: 'prdNameEn',
  direction: 'DESC',
  pageSize: 100
};

export const reducer = createReducer(
  initialState,

  on(UserActions.loadUsers, state => ({
    ...state,
    isLoading: true
  })),
  on(UserActions.loadUsersSuccess, (state, action) => ({
    ...state,
    users: action.users,
    total: action.total
  })),
  on(UserActions.loadUsersFailure, (state, action) => state),
  on(UserActions.loadUser, state => state),
  on(UserActions.loadUserSuccess, (state, action) => ({
    ...state,
    user: action.user
  })),
  on(UserActions.loadUsersFailure, (state, action) => state),
  on(UserActions.saveUserSuccess, (state, { user }) => ({
    ...state,
    users: [user, ...state.users]
  })),
  on(UserActions.updateUserSuccess, (state, { user }) => ({
    ...state,
    users: state.users.map((item)=> {
      if(item.usrID == user.usrID){
        return user
      }else{
        return item
      }
    }),
  })),
  on(UserActions.deleteUser, state => state),
  on(UserActions.deleteUserSuccess, (state, action) => ({
    ...state,
    users: state.users.filter(x => x.usrID != action.id)
  })),
  on(UserActions.noDeleteUserSuccess, (state, action) => ({
    ...state,
    //users: state.users.filter(x => x.usrID != action.id)
  })),
  on(UserActions.sortUsers, (state, action) => ({
    ...state,
  })),

  on(UserActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(UserActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(UserActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(UserActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(UserActions.resetUser, (state, action) => ({ 
    ...state,
    user: null
  })),
);

// function quickSort(array, type){
//   if (array.length <= 1) {
//     return array;
//   }

//   var pivot = array[0];
  
//   var left = []; 
//   var right = [];

//   for (var i = 1; i < array.length; i++) {
//     array[i].type < pivot.type ? left.push(array[i]) : right.push(array[i]);
//   }

//   return quickSort(left, type).concat(pivot, quickSort(right, type));

// }